import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import Work1 from "../../assets/Kitchen Remodel.webp";
import Work2 from "../../assets/Bathroom Remodel.jpg";
import Work3 from "../../assets/Living Room Renovation.jpg";
import Work4 from "../../assets/Garage Remodel.jpg";
import Work5 from "../../assets/gallary2.jpg";
import Work6 from "../../assets/gallery-5.jpg";
import Work7 from "../../assets/gallery-8.jpg";
import Work8 from "../../assets/gallery-4.jpg";
import Work9 from "../../assets/gallery-7.webp";
import Work10 from "../../assets/gallery-3.png";
import Work11 from "../../assets/gallery-6.jpg";
import Work12 from "../../assets/Modern-Kitchen-Remodel.jpg";

const OurWork = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const workData = [
    {
      image: Work1,
    },
    {
      image: Work2,
    },
    {
      image: Work3,
    },
    {
      image: Work4,
    },
    {
      image: Work5,
    },
    {
      image: Work6,
    },
    {
      image: Work7,
    },
    {
      image: Work8,
    },
    {
      image: Work9,
    },
    {
      image: Work10,
    },
    {
      image: Work11,
    },
    {
      image: Work12,
    },
  ];

  return (
    <Box
      id="ourWork"
      sx={{ padding: 4, marginLeft: isMobile ? "0" : "60px", width: "80%" }}
    >
      <Typography
        variant="h4"
        component="h2"
        gutterBottom
        sx={{ textAlign: "start", fontWeight: 700 }}
      >
        Our Work
      </Typography>
      <Typography
        variant="body1"
        paragraph
        sx={{ textAlign: "start", marginBottom: 4 }}
      >
        At Chicago Area Home Remodeling Contractor, we take pride in the quality
        of our work. Below are some examples of the projects we have completed,
        showcasing our commitment to excellence and attention to detail. From
        kitchen and bathroom remodels to complete home renovations, our team is
        dedicated to bringing your vision to life.
      </Typography>
      <Grid container spacing={4}>
        {workData.map((work, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image={work.image}
                alt={work.title}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default OurWork;
